/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_LoadingInputs */

const en_us2_profile_editors_loading = /** @type {(inputs: Profile_Editors_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading…`)
};

const pt_br2_profile_editors_loading = /** @type {(inputs: Profile_Editors_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carregando…`)
};

const es_419_profile_editors_loading = /** @type {(inputs: Profile_Editors_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cargando…`)
};

const pt_pt2_profile_editors_loading = /** @type {(inputs: Profile_Editors_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A carregar…`)
};

const fr_fr2_profile_editors_loading = /** @type {(inputs: Profile_Editors_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chargement…`)
};

const de_de2_profile_editors_loading = /** @type {(inputs: Profile_Editors_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wird geladen…`)
};

const it_it2_profile_editors_loading = /** @type {(inputs: Profile_Editors_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caricamento…`)
};

/**
* | output |
* | --- |
* | "Loading…" |
*
* @param {Profile_Editors_LoadingInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_loading = /** @type {((inputs?: Profile_Editors_LoadingInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_LoadingInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_loading(inputs)
	if (locale === "es-419") return es_419_profile_editors_loading(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_loading(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_loading(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_loading(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_loading(inputs)
	return en_us2_profile_editors_loading(inputs)
});
export { profile_editors_loading as "profile-editors.loading" }